<template>
<div>
  <b-form-group label="Attributes" label-cols-sm="3" label-cols-lg="3">
    <v-select multiple :options="attributeList" v-model="selected" :onChange="changeAttribute" placeholder="Select Attributes"></v-select>
  </b-form-group>
  <b-table ref="attributeTable" :items="items" :fields="fields" hover bordered table-responsive>
    <template v-slot:cell(#)="data">
      {{ data.index + 1 }}
    </template>
    <template v-slot:cell(attributeValue)="data">
      <div v-if="!data.item.editing">
        <b-button block variant="link" class="pull-left" @click="enableEditing(data.index)">{{data.item.attributeValue}}</b-button>
      </div>
      <div v-if="data.item.editing">
        <b-input type="text" v-model="tempValues[data.index]" class="input edit-attribute" :key="data.index" />
        <button @click="saveEdit(data.index)" class="btn btn-primary"><i class="cui-check icons font-1x2"></i></button>
        <b-button class="ml-1" @click="disableEditing(data.index)"><i class="fa fa-close icons font-1x2"></i></b-button>
      </div>
    </template>
    <template v-slot:cell(action)="data">
      <b-btn size="sm" class="btn-danger mb-2 mx-1" @click="onRemove(data.index)">Remove</b-btn>
    </template>

  </b-table>
  <b-button type="submit" variant="primary" @click="onSubmit">Submit</b-button>
  <b-button class="ml-1" type="button" @click="onCancel">Cancel</b-button>
</div>
</template>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
import {
  mapState,
  mapActions
} from 'vuex'

export default {
  name: 'SetAttributes',
  props: {
    object: Object,
    type: String
  },
  computed: {
  },
  data: () => {
    return {
      attributes: [],
      setStorePrice: false,
      attributeList: [],
      selected: [],
      selectedObjectAttributes: [],
      tempValues: [],
      fields: [
        '#',
        {
          key: 'attributeName',
          label: 'Attribute Name'
        },
        {
          key: 'attributeValue',
          label: 'Value'
        },
        'action',
      ],
      items: []
    }
  },
  methods: {
    enableEditing: function(index) {
      this.tempValues[index] = this.items[index].attributeValue;
      this.items[index].editing = true;
    },
    disableEditing: function(index) {
      this.tempValues[index] = null;
      this.items[index].editing = false;
    },
    saveEdit: function(index) {
      this.items[index].attributeValue = this.tempValues[index];
      this.disableEditing(index);
    },
    changeAttribute(selectedItems) {
      this.items = []
      _.forEach(selectedItems, (selectedItem) => {
        let attribute = selectedItem.value
        if (this.selectedObjectAttributes) {
          if (this.selectedObjectAttributes[attribute.id]) {
            this.items.push({
              attributeName: attribute.name,
              attributeValue: this.selectedObjectAttributes[attribute.id].value,
              attributeId: attribute.id,
              editing: false
            })
            this.tempValues.push(null)
            return;
          }
        }
        this.items.push({
          attributeName: attribute.name,
          attributeValue: attribute.default_value,
          attributeId: attribute.id,
          editing: false
        })
        this.tempValues.push(null)
      })
    },
    onSubmit() {
      let selectedItems = []

      _.forEach(this.items, (objectAttribute) => {
        if (objectAttribute.attributeValue) {
          selectedItems.push({
            value: objectAttribute.attributeValue,
            id: objectAttribute.attributeId
          })
        }
      })

      let params = {
        object_id: this.object.id,
        type: this.type,
        attributes: selectedItems
      }

      this.$store.dispatch('attributes/setAttributes', params)
        .then(() => {
          this.$emit('success')
          this.showSuccessMsg()
        })
        .catch((error) => {
          if (error.response.status == 422) {
            this.showErrorMsg({
              message: error.response.data.message
            })
          } else {
            this.showErrorMsg()
          }
        })

    },
    onRemove(index) {
      this.items.splice(index, 1);
      this.selected.splice(index, 1);
      // this.tempValues.splice(index,1);
    },
    onCancel() {
      this.$emit('cancel')
    }
  },
  created() {
    _.each(this.$store.state.attributes.actives, (attribute) => {
      if (attribute.type == this.type) {
        this.attributes.push(attribute)
      }
    })

    _.forEach(this.object.attributes, (objectAttribute) => {
      this.selectedObjectAttributes[objectAttribute.id] = objectAttribute
    })

    Vue._.forEach(this.attributes, (attribute) => {
      this.attributeList.push({
        label: attribute.name,
        value: attribute
      })

      if (this.selectedObjectAttributes[attribute.id]) {
        this.selected.push({
          label: attribute.name,
          value: attribute
        })

        // var attributeValue = this.selectedObjectAttributes[attribute.id].value;
        // this.items.push({
        //   attributeName: attribute.name,
        //   attributeValue: attributeValue,
        //   attributeId: attribute.id,
        //   editing: false
        // })
        // this.tempValues.push(null)

      }
    })
  }
}
</script>
<style lang="scss">
.edit-attribute {
    max-width: 80px;
    margin-right: 5px;
    padding: 5px;
    display: inline-block;
    float: left;
}
@media(max-width:480px) {
    .edit-attribute {
        display: block;
        width: 100%;
        margin-bottom: 5px;
        float: none;
    }
}
</style>
